/** Signing in: the login screen and the passkey ceremony behind it. */
export default {
    login: {
        subtitle: 'Sign in to continue',
        password: 'Password',
        submit: 'Sign in',
        submitting: 'Signing in…',
        passkey: 'Sign in with a passkey',
        passkeyWaiting: 'Waiting for passkey…',
        failed: 'Login failed.',
        throttled: 'Too many sign-in attempts. Try again in {n} minute. | Too many sign-in attempts. Try again in {n} minutes.',
        passkeyFailed: 'Passkey login failed.',
    },
    passkeys: {
        creationCancelled: 'Browser cancelled credential creation.',
        selectionCancelled: 'Browser cancelled passkey selection.',
    },
};
